function resizeParentAccordion(fromEl) {
	const panel = fromEl?.closest?.('.site-accordion__content, [class*="accordion"][class*="content"]');
	if (!panel) {
		return;
	}
	panel.style.maxHeight = panel.scrollHeight + 'px';
}

function attachAccessNewsletterHandlers() {
	// prevent multiple attaches
	if (window.__oltAccessNLAttached) {
		return;
	}
	window.__oltAccessNLAttached = true;

	document.addEventListener('submit', onSubmit, { capture: true });
	document.addEventListener('change', onChange, { capture: true });

	async function onSubmit(e) {
		const form = e.target;
		if (!(form instanceof HTMLFormElement) || !form.matches('form[data-newsletter-access]')) {
			return;
		}

		e.preventDefault();

		const nameEl = form.querySelector('#newsletter-access-name');
		const emailEl = form.querySelector('#newsletter-access-email');
		const consentEl = form.querySelector('#newsletter-access-consent');
		const errorEl = form.querySelector('#newsletter-access-form-error');
		const btn = form.querySelector('button[type="submit"]');

		// clear previous errors
		if (errorEl) {
			errorEl.textContent = ''; resizeParentAccordion(errorEl);
		}
		consentEl?.setCustomValidity?.('');

		// email required
		const email = (emailEl?.value || '').trim();
		if (!email) {
			if (errorEl) {
				errorEl.innerHTML = '<p>Please enter your email address.</p>'; resizeParentAccordion(errorEl);
			}
			emailEl?.focus();
			return;
		}
		// email valid
		const probe = document.createElement('input');
		probe.type = 'email'; probe.value = email;
		if (!probe.checkValidity()) {
			if (errorEl) {
				errorEl.innerHTML = "<p class='black'>Please enter a valid email address.</p>"; resizeParentAccordion(errorEl);
			}
			emailEl?.focus();
			return;
		}

		// consent required
		if (!(consentEl && consentEl.checked)) {
			if (errorEl) {
				errorEl.innerHTML = "<p class='black'>Please tick the consent box.</p>"; resizeParentAccordion(errorEl);
			}
			consentEl?.setCustomValidity?.('Please tick this box to receive our newsletter.');
			consentEl?.reportValidity?.();
			return;
		}

		// submit UX
		const prev = btn?.textContent;
		if (btn) {
			btn.disabled = true; btn.textContent = 'Submitting…';
		}

		const payload = {
			email,
			newsletterType: 'static',
			first_name: (nameEl?.value || '').trim(),
			accept_terms: true,
			opt_access_london_theatre: true
		};

		try {
			const res = await fetch('/wp-json/subscribers/all', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				credentials: 'same-origin',
				cache: 'no-store',
				body: JSON.stringify(payload)
			});

			if (res.ok) {
				form.innerHTML = "<h3 class='black'>Thank you for signing up.</h3>";
				resizeParentAccordion(form); // <— ensure the thanks message is visible in accordion
			} else {
				const msg = (await res.json().catch(() => ({})))?.error || 'Something went wrong.';
				if (errorEl) {
					errorEl.innerHTML = `<p>Sorry, we couldn't subscribe you. ${ String(msg).replace(/</g, '&lt;') }</p>`;
					resizeParentAccordion(errorEl);
				}
				if (btn) {
					btn.disabled = false; btn.textContent = prev || 'Submit »';
				}
			}
		} catch {
			if (errorEl) {
				errorEl.innerHTML = '<p>Network error. Please try again.</p>';
				resizeParentAccordion(errorEl);
			}
			if (btn) {
				btn.disabled = false; btn.textContent = prev || 'Submit »';
			}
		}
	}

	function onChange(e) {
		const el = e.target;
		if (!(el instanceof HTMLInputElement)) {
			return;
		}
		if (el.matches('#newsletter-access-consent')) {
			el.setCustomValidity('');
		}
		// also resize when user interacts; label help text may wrap differently
		resizeParentAccordion(el);
	}
}

// default export: only call once (the guard avoids duplicates)
export default function initAccessNewsletter() {
	attachAccessNewsletterHandlers();
}

if (typeof window !== 'undefined') {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', attachAccessNewsletterHandlers, { once: true });
	} else {
		attachAccessNewsletterHandlers();
	}
}
